<template>
    <main class="one-page" id="one-page">

        <section name="/home/" class="page--home d-flex align-items-center justify-content-center" id="home"
            :ref="'section'">
            <HomePage/>
        </section>

        <section name="/home/como_participar"
            class="page--como-participar d-flex align-items-center justify-content-center" id="como_participar"
            :ref="'section'">
            <ComoParticipar />
        </section>

        <section name="/home/premios" class="page--premios d-flex align-items-center justify-content-center"
            id="premios">
            <Premios />
        </section>

        <section name="/home/produtos_participantes"
            class="page--produtos-participantes d-flex align-items-center justify-content-center"
            id="produtos_participantes">
            <Produtos/>
        </section>
    </main>
</template>

<script>
import {scroller} from "vue-scrollto/src/scrollTo";
    export default {
        name: "Home",
        data() {
            return {

            }
        },
        components: {
            HomePage        : () => import('../pages/HomePage'),
            ComoParticipar  : () => import('../pages/ComoParticipar'),
            Produtos        : () => import('../pages/Produtos'),
            Premios         : () => import('../pages/Premios'),
        },

        mounted() {
            setTimeout(()=>{
                var params = this.$route.params.page;
                const firstScrollTo = scroller();
                if (!params) {
                    firstScrollTo("#home", 200, {offset : -80});
                } else {
                    firstScrollTo("#" + params, 200, {offset : -50});
                }

            }, 200)
        },
        beforeDestroy() {
            this.$parent.animateDestroy(); //-> Layout.vue
        }

    };
</script>

<style lang="scss" scoped>
    @import "../assets/scss/global";
    @import "../assets/scss/onepage";

</style>
